// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const VolumeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="VolumeIcon" ref={forwardedRef} {...props}>
      <path d="M6.25 13H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.25L11 2.5v15.003zM9.5 5.987 6.848 8.5H3.5v3h3.348L9.5 14.014z" />
      <path d="M13.775 10.063a3.74 3.74 0 0 0-1.152-2.704l1.062-1.06a5.23 5.23 0 0 1 1.59 3.764 5.23 5.23 0 0 1-1.51 3.686l-1.06-1.062a3.74 3.74 0 0 0 1.07-2.624" />
      <path d="m15.63 15.618-1.06-1.062a6.48 6.48 0 0 0 1.93-4.622 6.48 6.48 0 0 0-1.878-4.57l1.062-1.06A7.98 7.98 0 0 1 18 9.935a7.98 7.98 0 0 1-2.37 5.684" />
    </SvgIcon>
  );
});

/**
 * Use when the volume is turned on or louder
 * @public
 */
export const VolumeIcon = /* @__PURE__ */ Object.assign(VolumeIconComponent, {
  displayName: 'VolumeIcon',
});
